// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const glastrier: PokeData = {
  "id": 896,
  "name": "glastrier",
  "height": 22,
  "weight": 8000,
  "base_experience": 290,
  "types": [
    PokeType.ICE
  ],
  "api_moves": [
    "swords-dance",
    "stomp",
    "double-kick",
    "tackle",
    "take-down",
    "thrash",
    "double-edge",
    "tail-whip",
    "mist",
    "torment",
    "taunt",
    "iron-defense",
    "avalanche",
    "icicle-crash"
  ],
  "moves": [
    "double-kick",
    "tackle",
    "avalanche",
    "aurora-veil",
    "icicle-dagger",
    "sheer-cold",
    "blizzard",
    "ice-shard",
    "ice-wave",
    "chilly-reception",
    "hailstorm",
    "ice-fang",
    "ice-punch"
  ],
  "evolution_chain": {
    "id": 474,
    "item": null,
    "species": [
      {
        "name": "glastrier",
        "order": 896,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 154,
    "speed": 42,
    "ability_power": 204
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
